import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useState,
} from "react";

import type { TestRunDetails, WorklistNew } from "../types";

type WorklistContextProps = {
  run: TestRunDetails;
  worklist: WorklistNew;
  orders: WorklistNew["testOrders"];
  order: WorklistNew["testOrders"][0] | null;
  setOrder: Dispatch<SetStateAction<WorklistNew["testOrders"][0] | null>>;
};

const WorklistContext = createContext({} as WorklistContextProps);

export function WorklistProvider({
  children,
  ...props
}: { children: ReactNode } & Pick<
  WorklistContextProps,
  "run" | "worklist" | "orders"
>) {
  const [order, setOrder] = useState<WorklistContextProps["order"] | null>(
    null,
  );
  return (
    <WorklistContext.Provider value={{ ...props, order, setOrder }}>
      {children}
    </WorklistContext.Provider>
  );
}

export function useWorklist() {
  const context = useContext(WorklistContext);
  if (!context) {
    throw new Error("useWorklist must be called within WorklistProvider");
  }
  return context;
}
